
import { defineComponent } from 'vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import QBEFilterDialogDescriptor from './QBEFilterDialogDescriptor.json'

export default defineComponent({
    name: 'qbe-temporal-filter-dialog',
    components: { Column, DataTable, Dialog },
    props: { visible: { type: Boolean }, temporalFilters: { type: Array } },
    emits: ['save', 'close'],
    data() {
        return {
            QBEFilterDialogDescriptor,
            filters: [] as any,
            selectedFilter: null
        }
    },
    watch: {
        visible() {
            this.selectedFilter = null
        },
        temporalFilters() {
            this.loadTemporalFilters()
        }
    },
    created() {
        this.loadTemporalFilters()
    },
    methods: {
        loadTemporalFilters() {
            this.filters = this.temporalFilters
        },
        closeDialog() {
            this.$emit('close')
        },
        save() {
            this.$emit('save', this.selectedFilter)
        }
    }
})
